import { render, staticRenderFns } from "./onlineSubmission.vue?vue&type=template&id=3159372f"
import script from "./onlineSubmission.vue?vue&type=script&lang=js"
export * from "./onlineSubmission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports